<script setup>
import SalesService from '@services/resources/SalesService'

import { ref } from 'vue'

const props = defineProps({
  fetchPdf: {
    type: Function,
    required: false,
  },
  pdfContent: {
    type: String,
    required: false,
  },
})

const serviceSale = SalesService.build()

const loading = ref(false)
const error = ref(false)

const base64Pdf = ref('')
const pdfUrl = ref('')

async function openModal() {
    error.value = false
  loading.value = true

  try {
    const pdfContent = props.pdfContent || await props.fetchPdf();

    if(!pdfContent) throw new Error('No PDF content');

    base64Pdf.value = pdfContent;
    pdfUrl.value = `data:application/pdf;base64,${base64Pdf.value}`
  } catch (err) {
    error.value = true
  } finally {
    loading.value = false
  }
}
</script>

<template>
  <b-modal
    id="modal-view-pdf"
    hide-footer
    centered
    @shown="openModal"
  >
    <div class="container-pdf">
      <iframe
        v-if="!error && !loading"
        :src="pdfUrl"
        frameborder="0"
        type="application/pdf"
      />

      <div v-else-if="error" class="error-pdf">
        <p>O arquivo PDF não está disponível.</p>
      </div>

      <div v-else class="container-loading">
        <b-spinner />
      </div>
    </div>
  </b-modal>
</template>

<style lang="scss" scoped>
.container-pdf {
  margin: auto;
  width: 100%;

  position: relative;
  overflow: hidden;

  height: 100%;

  iframe {
    height: 100%;
    width: 100%;
    border-radius: 20px;
    background-color: #525659;
  }
}
.container-loading {
  width: 100%;
  height: 100%;

  display: grid;
  place-items: center;
}

.error-pdf {
  height: 100%;
  width: 100%;

  p {
    display: grid;
    place-items: center;
    height: 100%;

    font-weight: var(--weight-normal);
    color: var(--gray-200);
  }
}
</style>

<style>
#modal-view-pdf {
  .modal-dialog {
    max-width: 100% !important;
    max-height: 100% !important;
    height: 100% !important;
    margin: auto;
  }

  .modal-content {
    width: 100%;
    height: 94%;
    margin: 28px;
    border-radius: 20px;

    header {
      border: none;
      padding: 0;
      button {
        position: absolute;
        z-index: 999;
        top: 28px;
        right: 28px;

        width: 24px !important;
        height: 24px !important;

        background-color: #efefef;
        opacity: 1;
        border-radius: 999px;

        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }
    }
  }

  .modal-body {
    padding: 0 !important;
  }
}
</style>
